function isPermissionCode(value) {
  return typeof value === "string" && /^(E|P|R)[1-5]$|^N$/.test(value);
}

function extractPermissionCodes(rawPermissions) {
  if (!rawPermissions) return [];

  if (Array.isArray(rawPermissions)) {
    return rawPermissions.filter(isPermissionCode);
  }

  if (typeof rawPermissions === "object") {
    const codes = [];

    Object.entries(rawPermissions).forEach(([key, value]) => {
      if (value === true && isPermissionCode(key)) {
        codes.push(key);
      }

      if (isPermissionCode(value)) {
        codes.push(value);
      }

      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (isPermissionCode(item)) codes.push(item);
        });
      }
    });

    return Array.from(new Set(codes));
  }

  return [];
}

export function createPermissionChecker(userPermissions) {
  const permsInput = userPermissions?.permissions || userPermissions || [];
  const perms = extractPermissionCodes(permsInput);

  return {
    hasPermission(code) {
      return perms.includes(code);
    },

    hasAllPermissions(codes) {
      return codes.every(code => perms.includes(code));
    },

    hasAnyPermission(codes) {
      return codes.some(code => perms.includes(code));
    }
  };
}
